import { get } from 'lodash';
import template from 'url-template';

import {
    FETCH_KNOWI_CREDENTIALS
} from '../actions/actionTypes';

import awsHeader from '../helpers/awsAuth';
import lambdaBaseApi from '../apis/lambda';

import { areKnowiCredentialsValid } from '../helpers/auth';

import { handleNetworkError } from './applicationMessageActions';

const KnowiUrl = template.parse('/reports/sso');

export const fetchKnowiCredentials = () => async (dispatch, getState) => {
    const header = await awsHeader();

    const timestamp = getState().knowi.timestamp;

    if (timestamp && areKnowiCredentialsValid(timestamp)) { return; }

    try {
        const response = await lambdaBaseApi.post(
            KnowiUrl.expand(),
            {},
            header
        );

        const payload = get(response, 'data.data', {});

        dispatch({
            type: FETCH_KNOWI_CREDENTIALS,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const updateKnowiCredentials = () => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await lambdaBaseApi.post(
            KnowiUrl.expand(),
            {},
            header
        );

        const payload = get(response, 'data.data', {});

        dispatch({
            type: FETCH_KNOWI_CREDENTIALS,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};
